import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, BarChart3, Mail, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';

export const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 px-6 py-6 bg-white/80 backdrop-blur-lg border-b border-gray-200">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="relative">
              <TrendingUp className="h-7 w-7 text-[#C9A64A]" />
              <BarChart3 className="h-4 w-4 text-[#C9A64A] absolute -bottom-1 -right-1" />
            </div>
            <span className="text-xl font-bold text-[#1A1A1C] tracking-tight">Virtual<span className="text-[#C9A64A]">CFO</span></span>
          </Link>
          <Link to="/">
            <Button variant="outline" className="gap-2">
              <ArrowLeft className="h-4 w-4" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-b from-[#0F1A2A] to-[#1A1A1C] text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Get in Touch</h1>
          <p className="text-xl md:text-2xl text-gray-300 font-light leading-relaxed">
            Let's discuss how we can bring clarity to your finances.
          </p>
        </div>
      </section>

      {/* Contact Section - Email Focus */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Main Email Card */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#C9A64A]/10 mb-8">
              <Mail className="h-12 w-12 text-[#C9A64A]" />
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1C] mb-6">
              Reach Out to Us
            </h2>
            
            <p className="text-lg text-[#5A6270] mb-10 max-w-2xl mx-auto leading-relaxed">
              We prefer fewer partnerships where we can think deeply and deliver outcomes that matter. 
              Drop us an email and we'll get back to you.
            </p>

            {/* Prominent Email Display */}
            <div className="bg-gradient-to-br from-[#0F1A2A] to-[#1A1A1C] rounded-3xl p-10 md:p-14 shadow-2xl">
              <p className="text-[#C9A64A] text-sm font-semibold tracking-widest uppercase mb-4">
                Email Us At
              </p>
              <a 
                href="mailto:twopearlsprivatelimited@gmail.com" 
                className="text-2xl sm:text-3xl md:text-4xl font-bold text-white hover:text-[#C9A64A] transition-colors duration-300 break-all"
              >
                twopearlsprivatelimited@gmail.com
              </a>
              
              <div className="mt-8">
                <a 
                  href="mailto:twopearlsprivatelimited@gmail.com"
                  className="inline-flex items-center gap-3 bg-gradient-to-r from-[#C9A64A] to-[#D4B76A] text-[#0F1A2A] px-8 py-4 rounded-xl font-bold text-lg hover:scale-105 transition-transform duration-300 shadow-lg"
                >
                  <Mail className="h-5 w-5" />
                  Send an Email
                </a>
              </div>
            </div>
          </div>

          {/* Additional Info Cards */}
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl bg-[#C9A64A]/10 flex items-center justify-center">
                  <MapPin className="h-6 w-6 text-[#C9A64A]" />
                </div>
                <h3 className="text-xl font-bold text-[#1A1A1C]">Location</h3>
              </div>
              <p className="text-[#5A6270] leading-relaxed">
                Serving founders and businesses globally. We work remotely with clients across all time zones.
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl bg-[#C9A64A]/10 flex items-center justify-center">
                  <svg className="h-6 w-6 text-[#C9A64A]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-[#1A1A1C]">Response Time</h3>
              </div>
              <p className="text-[#5A6270] leading-relaxed">
                We typically respond to all inquiries within 24 hours during business days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
